import ObjectDetail from '../../classes/ObjectDetail';
import DetailOpener from "../../classes/DetailOpener";
import {stopAllAutoPlay} from "./preview_autoplay";
import $ from "jquery";


$( document ).ready(function (){
    if ( window.is_content_page ) {
        let $movie_detail_modal = $( '#movieDetailModal' );

        $movie_detail_modal.modal( {
            backdrop: true,
            show: false
        });

        $( '#movieDetailTab a' ).on( 'click', function (e) {
            e.preventDefault();
            $( this ).tab( 'show' );
        });

        $( '.trigger-detail:not( .bound )' ).addClass( 'bound' ).on( 'click',  function () {
            stopAllAutoPlay();
            displayModal();
            initModalMovieDetails( this );
        });

        new DetailOpener( document, window.location.href );
    }
});

export function initModalMovieDetails( that ) {
    let link_data = $( that ).data();
    if ( link_data.id && link_data.kind ) {

        let object_params = {
            kind: link_data.kind,
            object_id: link_data.id
        };

        if (link_data.provenance && link_data.provenance !== 'null' && link_data.provenance !== 'undefined' && link_data.provenance !== '') {
            object_params.provenance = link_data.provenance;
        }

        $.get( '/catalogs/object', object_params, function ( data ) {
            //console.log(data);
            processModalChanges( data );
            setMovieDetail( link_data.id, link_data.kind, 'info' );
        }).fail( function() {
            showError();
            setMovieDetail();
        });
    }
}



export function triggerSelectOptionTab( that ) {
    let $optionSelected = $("option:selected", that);
    let data = $optionSelected.data();
    if ( data.target ) {
        $( '.tab-pane-toggleable' ).removeClass('active');
        $( data.target ).css({
            "opacity":"0",
            "display":"block",
        }).tab("show")
            .animate({
                opacity: 1
            }, 1200);
    }
}

function processModalChanges( parsed_data ) {
    let modal_elements = modalElements();
    let object_detail = new ObjectDetail( parsed_data, modal_elements, window.const );
    try {
        object_detail.display();
        showInfo();
        object_detail.populateTabs();
        object_detail.setupAutoPlayPreview();
    } catch (e) {
        console.log('ERROR');
        console.log(e);
        showError();
        setMovieDetail();
    }
}

export function displayModal() {
    $('.modal-content-object-details').css({
        'box-shadow': 'none',
        'border': 'none'
    });

    showSpinner();

    $( '#movieDetailModal' ).modal('show');
}

function showSpinner() {
    $( '.content-details-toggleable' ).hide();

    modalSizeXl();

    $( '.content-details-spinner' ).show();
}

export function showInfo() {
    $( '.content-details-toggleable' ).hide();

    modalSizeXl();
    $('.modal-backdrop').css('opacity', '0');
    $( '.content-details-info' )
        .css({
            "opacity":"0",
            "display":"block",
        })
        .show()
        .animate({
            opacity: 1
        }, 800);

    $('.modal-content-object-details').css({
        'box-shadow': '0px 2px 35px #292929',
        'border': '1px solid rgba(0, 0, 0, 0.2)'
    });
}

function showError() {
    $( '.content-details-toggleable' ).hide();
    modalSizeXl();

    let $error = $( '.content-details-error' );
    $error.css({
        "opacity":"0",
        "display":"block",
    })
        .show()
        .animate({
            opacity: 1
        }, 800);

    $error.css({
        'box-shadow': '0px 2px 35px #292929',
        'border': '1px solid rgba(0, 0, 0, 0.2)'
    });
}

function modalSizeXl() {
    let $tvod = $('.modal-tvod-toggle');
    if ( $tvod && $tvod.length > 0 ) {
        if ( !$tvod.hasClass( "modal-xl" ) ) {
            $tvod.addClass('modal-xl');
        }
    }
}

export function setMovieDetail(id=null, kind=null, current=null) {
    window.content_detail = {
        id: id,
        kind: kind,
        current: current
    };
}

function modalElements() {
    let elements = {
        modal: document.getElementById('movieDetailModal'),
        sections: {}
    }

    elements.spinner = elements.modal.querySelector('.content-details-spinner');
    elements.info = elements.modal.querySelector('.content-details-info');
    elements.tvod = elements.modal.querySelector('.content-details-tvod');
    elements.tvod_content = elements.tvod.querySelector('.modal-body');

    elements.sections.details =  elements.modal.querySelector('.details');
    elements.sections.episode_details =  elements.modal.querySelector('.episode-details');
    elements.sections.actions = elements.modal.querySelector('.actions');
    elements.sections.tabs = elements.modal.querySelector('.tabs');

    let other_elements =  {
        screenshot: elements.modal.querySelector('.featured-screenshot'),
        details: {
            name: elements.sections.details.querySelector('.name'),
            progress: elements.sections.details.querySelector('.progress-container'),
            duration: elements.sections.details.querySelector('.duration'),
            imdb: elements.sections.details.querySelector('.imdb'),
            imdb_rating: elements.sections.details.querySelector('.imdb-rating'),
            imdb_votes: elements.sections.details.querySelector('.imdb-votes'),
            content_rating: elements.sections.details.querySelector('.content-rating'),
            content_rating_text: elements.sections.details.querySelector('.content-rating-text'),
            tags: elements.sections.details.querySelector('.tags'),
            movie: {
                container: elements.sections.details.querySelector('.description-container'),
                description: elements.sections.details.querySelector('.description')
            },
            seasons: elements.sections.details.querySelector('.seasons')
        },
        episode: {
            name: elements.sections.episode_details.querySelector('.episode-name'),
            description: elements.sections.episode_details.querySelector('.episode-description')
        },
        actions: {
            button: {
                rent: elements.sections.actions.querySelector('.tvod-rent'),
                buy: elements.sections.actions.querySelector('.tvod-buy'),
                resume: elements.sections.actions.querySelector('.watch-resume'),
                play: elements.sections.actions.querySelector('.watch-play'),
                trailer: elements.sections.actions.querySelector('.watch-trailer'),
                watchlist_add: elements.sections.actions.querySelector('.add-to-watchlist'),
                watchlist_remove: elements.sections.actions.querySelector('.remove-from-watchlist'),
                thumbs_up: elements.sections.actions.querySelector('.thumbs-up'),
                thumbs_down: elements.sections.actions.querySelector('.thumbs-down'),
            },
            span: {
                rent_amount: elements.sections.actions.querySelector('.rent-amount'),
                buy_amount: elements.sections.actions.querySelector('.buy-amount'),
                play: elements.sections.actions.querySelector('.watch-play-text')
            }
        },
        tabs: {
            toggleable: {
                episodes: elements.sections.tabs.querySelectorAll('.tab-toggleable-episodes'),
                suggested: elements.sections.tabs.querySelectorAll('.tab-toggleable-suggested'),
                extras: elements.sections.tabs.querySelectorAll('.tab-toggleable-extras'),
                details: elements.sections.tabs.querySelectorAll('.tab-toggleable-details')
            },
            links: {
                episodes: elements.sections.tabs.querySelector('.nav-link-episodes'),
                suggested: elements.sections.tabs.querySelector('.nav-link-suggested'),
                extras: elements.sections.tabs.querySelector('.nav-link-extras'),
                details: elements.sections.tabs.querySelector('.nav-link-details')
            },
            content: {
                episodes: elements.sections.tabs.querySelector('.tab-pane-episodes'),
                suggested: elements.sections.tabs.querySelector('.tab-pane-suggested'),
                extras: elements.sections.tabs.querySelector('.tab-pane-extras'),
                details: elements.sections.tabs.querySelector('.tab-pane-details')
            },
            container: {
                episodes: elements.sections.tabs.querySelector('.episodes'),
                suggested: elements.sections.tabs.querySelector('.suggested'),
                extras: elements.sections.tabs.querySelector('.extras'),
                details: elements.sections.tabs.querySelector('.details')
            },
            extras: {
                containers: elements.sections.tabs.querySelector('.extra-content'),
                links:  elements.sections.tabs.querySelector('.btn-extra'),
                quiz: elements.sections.tabs.querySelector('.btn-extra-quiz'),
                activity_book: elements.sections.tabs.querySelector('.btn-extra-activity-book'),
                lesson: {
                    link: elements.sections.tabs.querySelector('.btn-extra-lesson'),
                    title: elements.sections.tabs.querySelector('.btn-extra-lesson-title'),
                    description: elements.sections.tabs.querySelector('.btn-extra-lesson-description')
                },
            }
        }
    };

    return $.extend(elements, other_elements);
}
